import{
  FetchWordset,
  GetLanguage,
}from '../utils';

import {
  MODES,
}from '../const';

import {
  Loading
}from './';

var React = require('react');
var HelperScripts = require('../utils/HelperScripts.js');

class ListContainer extends React.Component {

  constructor(props){
    super(props);


    this.state = {
      list: [],
      shuffledList: [],
      progressList: [],
      language: null,
      loading: true,
      inActivity: false,
      mode: MODES.None,
      completedActs: this.getNewCompletedActs(),
      isAudioPlaying: false,
      isListView: false,
    }
  }



  componentDidMount(){
    this.checkPath();
    this.initializeLists();
  }

  componentDidUpdate(prevProps, prevState){
    if (prevProps.match.params.action !== this.props.match.params.action){
      this.checkPath();
      console.log("New Action detected!");
    }
    this.checkForExtraSlashes();
  }

  checkForExtraSlashes = () => {

    const {pid, action} = this.props.match.params;
    const {location} = this.props;

    if(location.pathname === `/${pid}/` && !this.props.match.params.hasOwnProperty("action")){
      this.props.history.replace(`/${pid}`);
      console.log("ALERT: Replaced url without action");
    }else if (location.pathname === `/${pid}/${action}/` && this.props.match.params.hasOwnProperty("action")){
      this.props.history.replace(`/${pid}/${action}`);
      console.log("ALERT: Replaced url with action");
    }
  }

  getLang = () => {
    const {pid, action} = this.props.match.params;

    return GetLanguage(pid);

  }

  changeView = () => {
    //Togle list view
    this.setState((prevState, prevProps) => ({
      isListView: !prevState.isListView,
    }));
  }

  checkPath = (nextAction) => {

    let action = this.props.match.params.action;

    if(nextAction){
      action = nextAction;
    }

    //If there is no action, main menu and mode = None
    if (!action){

      this.setState({
        mode: MODES.None,
        inActivity: false,
      });
      return;
    }

    //If there is an action, go into the activity
    let mode = this.modeFromAction(action);
    this.initializeAct(mode);
  }

  modeFromAction = (modeAction) => {

    if(!modeAction) {
      console.log("ERROR: No action passed to ListContainer!");
      return null
    }

    for(let mode in MODES){
      if (MODES[mode].action === modeAction){

        return({...MODES[mode]});
      }
    }
  }

  initializeAct = (id) => {

    console.log(id);

    const mode = {...id}; //Make copy of mode object

    //Update mode and set inActivity

    this.setState({
      mode: mode,
      inActivity: true,
    }, this.initializeLists()); //Run initializeLists as callback
  }

  exitActivity = () => {
    this.setState({
      mode: MODES.None,
      inActivity: false,
    });

    this.props.history.replace(`/${this.props.match.params.pid}`);
  }

  initializeLists = () => {

    const {pid} = this.props.match.params;

    let list, shuffledList, progressList = [];

    if (!this.state.language){
      //Get Language
      this.getLang()
      .then(data => {
        console.log(data);
        this.setState({
          language: data,
        })
      });
    }
    
    FetchWordset(pid)
      .then(results => {
        console.log(results.length);
        console.log(results);
        if(results.length > 0){
          list = results;
          //Arrow function throws error for some reason...
          shuffledList = HelperScripts.ShuffleArray(results);
          progressList = this.initializeProgressList(this.state.mode, list, shuffledList);

          this.setState({
            list: list,
            shuffledList: shuffledList,
            progressList: progressList,
            loading: false,
          })

        }else{
          alert("The wordset introduced does not exist");
        }
      })
      .catch((error) => {
        alert("There was a problem connecting to the database, check your connection and try again");
        console.log(error);
      });
  }

  initializeProgressList = (newMode, list, shuffledList) => {

    let newListProgress = (newMode.isShuffled) ? JSON.parse(JSON.stringify(shuffledList)) : JSON.parse(JSON.stringify(list));

    for (let item in newListProgress){
      newListProgress[item].isCorrect = false;
      newListProgress[item].wasChecked = false;
      newListProgress[item].props = {};
    }

    return  newListProgress;

  }

  getNewCompletedActs = () => {
    const completedActs = {};

    for (let mode in MODES) {
      completedActs[mode] = {...MODES[mode]};
    };

    return completedActs;
  }

  updateCompletedActs = (id, score = 0) => {
    let currCompleted = {...this.state.completedActs};

    console.log(id, score);

    currCompleted[id].completed = true;
    currCompleted[id].score = score;

    this.setState({
      completedActs: currCompleted,
    }, this.exitActivity)

  }

  updateProgressList = ({word , ...restProp}) => {
    if (word){
      const {progressList} = this.state;

      const {isCorrect, wasChecked, ...props} = restProp;

      let newListItem = progressList.findIndex(x => x.word === word);

      progressList[newListItem].isCorrect = (isCorrect) ? isCorrect : false;
      progressList[newListItem].wasChecked = (wasChecked) ? wasChecked : false;
      progressList[newListItem].props = {...props};

      this.setState({
        progressList: progressList,
      })
    }
  }

  setAudioFalse = () => {
    this.setState({
      isAudioPlaying: false,
    })
  }

  toggleAudio = () => {
    this.setState((prevState, props) => ({
      isAudioPlaying: !prevState.isAudioPlaying
    }))
  }

  render() {

    const {children, ...other} = this.props;

    const stateToPass = this.state;

    const initializeAct = this.initializeAct;
    const exitActivity = this.exitActivity;
    const updateCompletedActs = this.updateCompletedActs;
    const toggleAudio = this.toggleAudio;
    const changeView = this.changeView;
    const setAudioFalse = this.setAudioFalse;
    const updateProgressList = this.updateProgressList;

    //Pass props and state to all children
    const childrenToRender = React.Children.map(this.props.children,
     (child) => React.cloneElement(child, {
       ...other,
       initializeAct,
       updateCompletedActs,
       updateProgressList,
       toggleAudio,
       setAudioFalse,
       changeView,
       exitActivity,
       ...stateToPass,
      },
     )
    );

    //Show children if not loading
    if(this.state.loading){
      return(
        <Loading />
      )
    }else{
      return(
        <div>
          {childrenToRender}
        </div>
      )
    }

  }
}

export default ListContainer;



// WEBPACK FOOTER //
// ./src/comp/ListContainer.js